import global from './global'
import utility from './utility'

const lotteryQuickPlay = {
    timeout: null,

    init: function() {
        this.renderQuickPlay();

        const bannerDraws = document.getElementById("banner-draws");
        if (bannerDraws) {
            [...bannerDraws.querySelectorAll(".lottery-card")].map(quickPlay => {
                quickPlay.onclick = (e) => {
                    if (quickPlay.classList.contains("active")) {
                        return;
                    }
                    const form = e.currentTarget.querySelector("form");
                    if (!form) {
                        return;
                    }
                    // Submit to form action - Syndicate quickplay
                    if (quickPlay.classList.contains("lottery-card-syndicate")) {
                        form.submit();
                        return;
                    }
                    utility.addClass(quickPlay, "active");
                    lotteryQuickPlay.requestQuickPlay(form);
                    setTimeout(() => {
                        utility.removeClass(quickPlay, "active");
                    }, 2000);
                }
            });
        }

        const bannerPlayButton = document.getElementById("lottery-game--banner-play");
        if (bannerPlayButton) {
            bannerPlayButton.onclick = () => {
                const el = document.querySelector("[data-tab='lottery-game--play-now']");
                if (el) {
                    el.click();
                }
            };
        }

        const bannerInfoButton = document.getElementById("lottery-game--banner-info");
        if (bannerInfoButton) {
            bannerInfoButton.onclick = () => {
                const el = document.querySelector("[data-tab='lottery-game--play-now']");
                if (el) {
                    el.click();
                }
            };
        }

        [...document.querySelectorAll(".add-game-favourites")].map(button => {
            button.onclick = (e) => {
                lotteryQuickPlay.requestFavouritesPlay(e.currentTarget);
            };
        });
    },

    renderQuickPlay: function () {
        [...document.querySelectorAll(".lottery-card--quickplay")].map(quickPlay => {
            quickPlay.onclick = (e) => {
                if (quickPlay.classList.contains("active")) {
                    return;
                }
                utility.addClass(quickPlay, "active");
                const form = e.currentTarget.querySelector("form");
                lotteryQuickPlay.requestQuickPlay(form);
                setTimeout(() => {
                    utility.removeClass(quickPlay, "active");
                }, 2000);
            }
        });
    },

    handleHeader: function() {
        lotteryQuickPlay.timeout = setTimeout(() => {
            const header = document.querySelector("#header");
            utility.removeClass(header, "cart-active");
        }, 3000);
    },

    requestFavouritesPlay: function(button) {
        const ajaxOptions = {
            url: "/api/web/account/play-saved-games",
            method: "POST",
            data: "systemEntryId=" + button.dataset.id + "&lotteryDrawId=" + button.dataset.drawid + "&sourceId=" + button.dataset.source,
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.result === "S") {
                    global.updateCartSummary(lotteryQuickPlay.showCart);
                }
                else {
                    utility.showNotificationPopup({
                        title: "You don't have any saved games",
                        content: "To set some up, click on the heart icon once you've selected numbers."
                    });
                }
            },
            always: function() {
                utility.enableButton(button);
            }
        };
        utility.disableButton(button);
        utility.ajaxRequest(ajaxOptions);
    },

    requestQuickPlay: function(form) {
        const ajaxOptions = {
            url: form.getAttribute("action"),
            method: "POST",
            data: utility.getFormData(form),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    global.updateCartSummary(lotteryQuickPlay.showCart);
                }
                else {
                    const errorMessage = result.message !== "" ? result.message : "An unknown error has occurred";
                    utility.showNotificationPopup({
                        title: "Error",
                        content: errorMessage
                    });
                }
            },
            always: function() {
                utility.enableButton(document.getElementById("play-now--play-favourites-quick"));
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    showCart: function() {
        if (window.innerWidth > 980) {
            setTimeout(() => {
                    if (lotteryQuickPlay.timeout) {
                        clearTimeout(lotteryQuickPlay.timeout);
                    }
                    const header = document.querySelector("#header");
                    utility.addClass(header, "cart-active");
                    lotteryQuickPlay.handleHeader();
                },
                1000);
        }
        else {
            setTimeout(() => {
                    window.location.href = "/checkout";
                },
                800);
        }
    }
}

export default lotteryQuickPlay


// WEBPACK FOOTER //
// ./assets/src/js/classes/lotteryQuickPlay.js